import { render, staticRenderFns } from "./MahkemePicker.vue?vue&type=template&id=05036656"
import script from "./MahkemePicker.vue?vue&type=script&lang=ts"
export * from "./MahkemePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports